'use client'

import { X } from 'lucide-react'
import Link from 'next/link'
import React, { useEffect, useState } from 'react'
import Bars3Icon from '../icons/bars-3'
import GridFinderLogo from '../icons/logos/grid-finder-new'

const NAV_LINKS = [
  { href: '/news', label: 'News' },
  { href: '/updates', label: 'Patch Notes' },
]

export default function StaticHeader() {
  const [isVisible, setIsVisible] = useState(true)
  const lastScrollY = React.useRef(0)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  useEffect(() => {
    const controlNavbar = () => {
      const currentScrollY = window.scrollY

      if (currentScrollY > 100) {
        if (currentScrollY > lastScrollY.current) {
          // Scrolling DOWN
          setIsVisible(false)
        } else {
          // Scrolling UP
          setIsVisible(true)
        }
      } else {
        // At top of page
        setIsVisible(true)
      }

      lastScrollY.current = currentScrollY
    }

    window.addEventListener('scroll', controlNavbar)
    return () => window.removeEventListener('scroll', controlNavbar)
  }, [])

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [isMobileMenuOpen])

  return (
    <>
      <header
        className={`supports-backdrop-filter:bg-neutral-blue-900/60 sticky top-0 z-50 w-full border-b border-white/10 bg-neutral-blue-900/95 backdrop-blur-sm transition-transform duration-300 ${isVisible ? 'translate-y-0' : '-translate-y-full'}`}
      >
        <div className="mx-auto flex h-16 w-full max-w-[1920px] items-center justify-between px-6 md:px-12">
          <div className="flex items-center gap-8">
            <Link
              href="/"
              className="flex items-center transition-opacity hover:opacity-80"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <GridFinderLogo className="w-[120px] fill-white" />
            </Link>

            <nav className="hidden items-center gap-6 text-sm font-medium text-white/80 md:flex">
              {NAV_LINKS.map((link) => (
                <Link
                  key={link.href}
                  href={link.href}
                  className="transition-colors hover:text-white"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          <div className="flex items-center gap-4">
            <Link
              href="/"
              className="hidden text-sm font-medium text-white/60 hover:text-white md:block"
            >
              Back to App
            </Link>

            <div className="flex items-center md:hidden">
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="focus:outline-hidden rounded-sm text-white focus:ring-2 focus:ring-white"
                aria-expanded={isMobileMenuOpen}
                aria-controls="mobile-menu"
              >
                {isMobileMenuOpen ? (
                  <X className="size-8 stroke-white" />
                ) : (
                  <Bars3Icon className="w-8 stroke-white" />
                )}
              </button>
            </div>
          </div>
        </div>
      </header>
      {isMobileMenuOpen && (
        <div
          id="mobile-menu"
          className="fixed inset-0 z-40 flex flex-col bg-neutral-blue-900 px-6 pb-6 pt-24 md:hidden"
        >
          <div className="flex-1 overflow-y-auto">
            <div className="flex flex-col gap-1">
              {NAV_LINKS.map((link) => (
                <Link
                  key={link.href}
                  href={link.href}
                  className="hover:text-gf-purple-400 border-b border-white/10 py-3 text-xl font-bold text-white transition-colors"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div className="mt-auto pb-10 pt-6">
            <Link
              href="/"
              className="flex w-full items-center justify-center rounded-md bg-white py-3 font-bold text-neutral-blue-900 transition-colors hover:bg-gray-200"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Back to App
            </Link>
          </div>
        </div>
      )}
    </>
  )
}
